module.exports = __webpack_public_path__ + "assets/img/footer_style.beedc13a.svg";